import { register } from "@rill/loader";
import { whoIsAthleteCoach } from "../utils/user-helpers";

register(
  {
    name: "calendarEvents",
    meta: ["no-bust", "user"],
    ttl: "2 hours",
  },
  async ({ api, locals }, { coach, athleteId }) => {
    const organizationCoach = locals.query.organizationCoach || undefined;
    const organizationCoachId = organizationCoach
      ? whoIsAthleteCoach(
          locals.activeUser.athletes,
          athleteId,
          locals.activeUser._id,
          organizationCoach
        )
      : undefined;

    let query = {
      athleteId,
      coach,
    };

    if (organizationCoachId) {
      query = { ...query, organizationCoachId };
    }

    const res = await api("calendar-event", {
      method: "GET",
      query,
    });
    return res.json();
  }
);

register(
  {
    name: "phasesTemplates",
    meta: ["no-bust", "user"],
    ttl: "2 hours",
  },
  async ({ api, locals }, { coach, athleteId }) => {
    let query = {
      athleteId,
      coach,
    };

    const organizationCoach = locals.query.organizationCoach || undefined;
    const organizationOwnerId = locals.organizationOwner?._id;
    const organizationCoachId = organizationCoach
      ? whoIsAthleteCoach(
          locals.activeUser.athletes,
          athleteId,
          locals.activeUser._id,
          organizationCoach
        )
      : undefined;

    if (organizationCoachId) {
      query = { ...query, organizationCoachId };
    }
    // If there is the organization owner, we need to fetch the templates from the organization owner
    organizationOwnerId && (query = { ...query, organizationOwnerId });

    const res = await api("coach-phase-template", {
      method: "GET",
      query,
    });
    return res.json();
  }
);

register(
  {
    name: "athletePhases",
    meta: ["no-bust", "user"],
    ttl: "2 hours",
  },
  async ({ api, locals }, { coach, athleteId }) => {
    const organizationCoach = locals.query.organizationCoach || undefined;

    const organizationCoachId = organizationCoach
      ? whoIsAthleteCoach(
          locals.activeUser.athletes,
          athleteId,
          locals.activeUser._id,
          organizationCoach
        )
      : undefined;

    let query = {
      athleteId,
      coach,
    };

    if (organizationCoachId) {
      query = { ...query, organizationCoachId };
    }

    const res = await api("athlete-phases", {
      method: "GET",
      query,
    });

    return res.json();
  }
);

register(
  {
    name: "athleteVolumes",
    meta: ["no-bust", "exercise"],
    ttl: "2 hours",
  },
  async ({ api }, { athleteId, monthFrom, monthTo }) => {
    const res = await api("athlete-volumes", {
      method: "GET",
      query: {
        athleteId,
        monthFrom,
        monthTo,
      },
    });

    const data = await res.json();

    return data.volumes;
  }
);

register(
  {
    name: "athleteStats",
    meta: ["no-bust", "daily-stats"],
    ttl: "2 hours",
  },
  async ({ api }, { athleteId, monthFrom, monthTo }) => {
    const res = await api("athlete-stats", {
      method: "GET",
      query: {
        athleteId,
        monthFrom,
        monthTo,
      },
    });

    const data = await res.json();

    return data.stats;
  }
);
